import { memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { StyledTextBox, StyledTypography } from './styled'

interface IProps {
  width: number
  index: number
}

export const LeftPart = memo(function LeftPart({ width, index }: IProps) {
  useTranslation()

  return (
    <StyledTextBox>
      <StyledTypography
        variant="text16Medium"
        fontSize={width / 37.5}
        top="38%"
        opacity={index < 6}
      >
        <Trans
          ns="widgets"
          i18nKey="for startups.how to onboard my fintech.info graph.4"
          components={{ span: <span /> }}
        />
      </StyledTypography>

      <StyledTypography
        variant="text16Medium"
        fontSize={width / 37.5}
        top="67%"
        opacity={index < 5}
      >
        <Trans
          ns="widgets"
          i18nKey="for startups.how to onboard my fintech.info graph.5"
          components={{ span: <span /> }}
        />
      </StyledTypography>
    </StyledTextBox>
  )
})
